import { render, staticRenderFns } from "./ArtPerfCorp.vue?vue&type=template&id=59a9bbe1&"
import script from "./ArtPerfCorp.vue?vue&type=script&lang=ts&"
export * from "./ArtPerfCorp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports